var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Subaccounts ")]),
      _c(
        "gg-card-text",
        [
          _c("v-simple-table", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function fn() {
                  return [
                    _c("thead", [
                      _c("tr", [
                        _c(
                          "th",
                          {
                            staticClass: "text-left"
                          },
                          [_vm._v(" Username ")]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "text-left"
                          },
                          [_vm._v(" Scheduled For ")]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "text-left"
                          },
                          [_vm._v(" Completed At ")]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "text-left"
                          },
                          [_vm._v(" Status ")]
                        )
                      ])
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.subMigrations, function(subMigration) {
                        return _c(
                          "tr",
                          {
                            key: "sm-".concat(subMigration.id)
                          },
                          [
                            _c("td", [
                              _vm._v(
                                " " + _vm._s(subMigration.resold_username) + " "
                              )
                            ]),
                            _c("td", [
                              _vm._v(
                                " " + _vm._s(subMigration.scheduled_for) + " "
                              )
                            ]),
                            _c("td", [
                              _vm._v(
                                " " + _vm._s(subMigration.completed_at) + " "
                              )
                            ]),
                            _c(
                              "td",
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mb-1",
                                    attrs: {
                                      small: "",
                                      color: _vm.migrationStatusColor(
                                        subMigration.status
                                      )
                                    }
                                  },
                                  [_vm._v(" mdi-circle ")]
                                ),
                                _vm._v(" " + _vm._s(subMigration.status) + " ")
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }